<template>
	<div>
		<!-- context menu -->
		<v-menu v-model="ListBottomMenu" :position-x="x" :position-y="y" absolute offset-y>
			<v-list dense>
				<v-list-item v-for="(item, index) in ListBottomItem" :key="index" class="cursor"
					@click="emitListMenu(item)">
					<v-list-item-title>{{ item.text }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
		<v-row :style="stylechat" class="justify-start" v-for="(item, index) in listchat" :key="index">
			<!-- system message -->
			<v-col cols="12"
				v-if="index == 0 || dateMoment(listchat[index - 1].timestamp) != dateMoment(item.timestamp)">
				<div v-if="index == 0" class="systemDateNonMGT CSChatThai pl-2 pr-2" style="text-align: center;">
					<span>{{ dateMoment(item.timestamp) }}</span>
				</div>
				<div v-else-if="dateMoment(listchat[index - 1].timestamp) != dateMoment(item.timestamp)"
					class="systemDate CSChatThai pl-2 pr-2" style="text-align: center;">
					<span>{{ dateMoment(item.timestamp) }}</span>
				</div>
			</v-col>
			<!-- check box self -->
			<v-col
				v-if="statusForward && item.tokenuser === tokenuser && (item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task')"
				cols="1" align="center" :class="checkTypeMessage(item.typeofmessage) ? 'dis-cursor' : ''">
				<!-- bg-checkbox -->
				<v-row class="justify-center align-center ml-3">
					<v-checkbox v-model="selectedForward" :key="item.tokenmessage" :disabled="!(item.typeofmessage === 'message' ||
						item.typeofmessage == 'image' ||
						item.typeofmessage === 'file' ||
						item.typeofmessage === 'pdf_password' ||
						item.typeofmessage === 'video' ||
						item.typeofmessage === 'location')" hide-details :value="item.tokenmessage"
						:value-comparator="compareItems">
					</v-checkbox>
					<!-- {{item.typeofmessage}} -->
				</v-row>
			</v-col>
			<v-col :ref="`messageType-${item.tokenmessage}`" :id="item.tokenmessage"
				:cols="statusForward && item.tokenuser === tokenuser && (item.typeofmessage !== 'unsend_message' || item.typeofmessage == 'system' || item.typeofmessage == 'system_action' || item.typeofmessage == 'system_action_albums' || item.typeofmessage === 'system_action_task') ? '11' : '12'"
				:class="!statusForward ? checkClassChatNotForward(item) : checkClassChat(item, statusForward)">
				<div class="system"
					v-if="item.typeofmessage == 'unsend_message' || item.typeofmessage == 'system' || item.typeofmessage == 'system_action' || item.typeofmessage == 'system_action_albums' || item.typeofmessage === 'system_action_task'">
					<div class="systemDate CSChatThai pl-2 pr-2" style="text-align: center;"
						v-if="item.typeofmessage == 'unsend_message'" :id="item.tokenmessage">
						<span v-if="item.tokenuser === tokenuser">{{ $t('ChatSide.system.self.cancelMsg') }}</span>
						<span v-else>{{ $t('ChatSide.system.other.cancelMsg', { name: item.nickname }) }}</span>
					</div>
					<div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;"
						v-else-if="item.typeofmessage == 'system'" :id="item.tokenmessage">
						<span>{{ item.message }}</span>
					</div>
					<div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;"
						v-else-if="item.typeofmessage == 'system_action_albums'" :id="item.tokenmessage">
						<span class="boxself_system" v-if="item.message === 'edit_name_albums'">
							{{ item.tokenuser === tokenuser ?
								$t('ChatSide.system.self.editNameAlbum') :
								$t('ChatSide.system.other.editNameAlbum', { name: item.nickname })
							}}
						</span>
						<span class="boxself_system" v-if="item.message === 'create_albums'">
							{{ item.tokenuser === tokenuser ?
								$t('ChatSide.system.self.createAlbum', { name: item.albums_name }) :
								$t('ChatSide.system.other.createAlbum', {
									name: item.nickname, album_name: item.albums_name
								})
							}}
						</span>
						<span class="boxself_system" v-if="item.message === 'delete_albums'">
							{{ item.tokenuser === tokenuser ? $t('ChatSide.system.self.deleteAlbum') :
								$t('ChatSide.system.other.deleteAlbum', { name: item.nickname }) }}
						</span>
						<span class="boxself_system" v-if="item.message === 'delete_images_albums'">
							{{ item.tokenuser === tokenuser ? $t('ChatSide.system.self.deleteImageAlbum') :
								$t('ChatSide.system.other.deleteImageAlbum', { name: item.nickname }) }}
						</span>
					</div>
					<div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;"
						v-else-if="item.typeofmessage == 'system_action_task'" :id="item.tokenmessage">
						<span class="boxself_system" v-if="item.message === 'edit_task'">
							{{ $t('ChatSide.system.self.editTask') }}
						</span>
						<span class="boxself_system" v-if="item.message === 'create_project'">
							{{ $t('ChatSide.system.self.createProject') }}
						</span>
					</div>
					<div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;"
						v-else-if="item.typeofmessage == 'system_action'" :id="item.tokenmessage">
						<span class="boxself_system" v-if="item.message === 'active'">
							<span>{{ timeMoment(item.timestamp) }}</span>
							<br>
							<span v-if="item.tokenuser === tokenuser">{{ $t('ChatSide.system.self.joinGroup') }}</span>
							<span v-else>{{ $t('ChatSide.system.other.joinGroup', { name: item.file_name }) }}</span>
						</span>
						<span class="boxself_system" v-else-if="item.message === 'kick'">
							<span>{{ timeMoment(item.timestamp) }}</span>
							<br>
							{{ $t('ChatSide.system.default.kickMemberGroup', {
								name_active: item.nickname, name_passive:
									item.file_name
							}) }}
						</span>
						<span class="boxself_system" v-else-if="item.message === 'invite'">
							<span>{{ timeMoment(item.timestamp) }}</span>
							<br>
							{{ $t('ChatSide.system.default.inviteMemberGroup', {
								name_active: item.nickname, name_passive:
									item.file_name
							}) }}
						</span>
						<span class="boxself_system" v-else-if="item.message === 'leave'">
							<span>{{ timeMoment(item.timestamp) }}</span>
							<br>
							<span v-if="item.tokenuser === tokenuser">{{ $t('ChatSide.system.self.leftGroup') }}</span>
							<span v-else>{{ $t('ChatSide.system.other.leftGroup', { name: item.file_name }) }}</span>
						</span>
					</div>
				</div>
				<div v-else>
					<v-row class="ml-3 align-end" v-if="item.tokenuser !== tokenuser">
						<div v-if="index == 0">
							<div class="username CSChatThai cursor"
								v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action_albums'">
								<v-row justify="start" class="mb-2 mt-2">
									<v-avatar size="40" @click="openMessage('detailfriend', item)">
										<img v-if="item.path_pic" :src="item.path_pic"
											class="imgProfilechat pictureRoomChat alligator-turtle" />
										<img v-else-if="item.type === 'bot'"
											:src="`${publicPath}/assets/img/default_profile/bot-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
										<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
									</v-avatar>
									<p class="text-overflow mb-0 pl-3">{{ item.nickname }}</p>
								</v-row>
							</div>
						</div>
						<div
							v-else-if="(listchat[index - 1].tokenuser == tokenuser) || (dateMoment(item.timestamp) != dateMoment(listchat[index - 1].timestamp))">
							<div class="username CSChatThai cursor"
								v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system'">
								<v-row justify="start" class="mb-2 mt-2">
									<v-avatar size="40" @click="openMessage('detailfriend', item)">
										<img v-if="item.path_pic" :src="item.path_pic"
											class="imgProfilechat pictureRoomChat alligator-turtle" />
										<img v-else-if="item.type === 'bot'"
											:src="`${publicPath}/assets/img/default_profile/bot-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
										<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
									</v-avatar>
									<p class="text-overflow mb-0 pl-3">{{ item.nickname }}</p>
								</v-row>
							</div>
						</div>
						<div v-else-if="listchat[index - 1].typeofmessage === 'unsend_message' ||
							listchat[index - 1].typeofmessage === 'system_action_task' ||
							listchat[index - 1].typeofmessage === 'system_action_albums' ||
							listchat[index - 1].typeofmessage === 'system_action' ||
							listchat[index - 1].typeofmessage === 'system'
						">
							<div class="username CSChatThai cursor"
								v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system'">
								<v-row justify="start" class="mb-2 mt-2">
									<v-avatar size="40" @click="openMessage('detailfriend', item)">
										<img v-if="item.path_pic" :src="item.path_pic"
											class="imgProfilechat pictureRoomChat alligator-turtle" />
										<img v-else-if="item.type === 'bot'"
											:src="`${publicPath}/assets/img/default_profile/bot-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
										<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
									</v-avatar>
									<p class="text-overflow mb-0 pl-3">{{ item.nickname }}</p>
								</v-row>
							</div>
						</div>
					</v-row>
					<v-row
						:class="statusForward && item.tokenuser !== tokenuser ? 'align-end ml-3 mb-3 mr-2 mt-0' : 'align-end ml-14 mb-3 mr-2 mt-0'">
						<div v-if="item.tokenuser === tokenuser && item.status_send === undefined" class="mr-2">
							<!-- {{ typeRoom }} -->
							<span class="fz-11 color-grey"
								v-if="typeRoom === 'group' && checkCountRead(item.read) !== 0">{{
									$t('ChatSide.countread') }} {{ checkCountRead(item.read) }}</span>
							<span class="fz-11 color-grey"
								v-else-if="typeRoom !== 'group' && checkCountRead(item.read) !== 0">{{
									$t('ChatSide.countread') }}</span>
							<br>
							<span class="fz-11 color-grey">{{ timeMoment(item.timestamp) }}</span>
						</div>
						<div v-else-if="item.tokenuser === tokenuser && item.status_send !== undefined" class="mr-2">
							<span class="custom-loader" v-if="item.status_send === 'loading'">
								<v-icon light>mdi-cached</v-icon>
							</span>
						</div>
						<!-- check box friend -->
						<div :class="checkTypeMessage(item.typeofmessage) ? 'dis-cursor' : ''">
							<v-checkbox v-model="selectedForward" :key="item.tokenmessage" :disabled="!(item.typeofmessage === 'message' ||
								item.typeofmessage == 'image' ||
								item.typeofmessage === 'file' ||
								item.typeofmessage === 'pdf_password' ||
								item.typeofmessage === 'video' ||
								item.typeofmessage === 'location')" v-if="item.tokenuser !== tokenuser && statusForward" hide-details
								:value="item.tokenmessage" :value-comparator="compareItems">
							</v-checkbox>
						</div>
						<!-- message loading -->
						<div class="message" v-if="item.typeofmessage === 'loading'">
							<v-row
								:class="item.value_loading !== 100 ? 'justify-start align-center' : 'justify-start align-center pb-3'">
								<v-col v-if="item.status_send !== 'error'" cols="3" justify="center" align="center"
									class="pb-0">
									<v-icon class="iconfile">{{ extension(item.file_name) }}</v-icon>
								</v-col>
								<v-col v-if="item.status_send === 'error'" cols="3" justify="center" align="center"
									class="pb-0">
									<v-icon class="iconfile-error">fa-solid fa-triangle-exclamation</v-icon>
								</v-col>
								<v-col cols="9" class="pb-0">
									<p class="text-overflow-contact mb-0 pl-0">{{ item.file_name }}</p>
									<span>{{ item.file_size }}</span>
								</v-col>
							</v-row>
							<v-row v-if="item.status_send === 'loading'" class="justify-center align-center mt-0">
								<v-col cols="9">
									<v-progress-linear v-model="item.value_loading" height="15" rounded
										:value="Math.ceil(item.value_loading)">
										<strong class="color-white">{{ Math.ceil(item.value_loading) }}%</strong>
									</v-progress-linear>
								</v-col>
								<v-col cols="3" class="pl-0" align="center" @click="cancelUpload(item, index)">
									<v-btn text icon class="iconcontact">
										<v-icon>mdi-close-circle</v-icon>
									</v-btn>
								</v-col>
							</v-row>
							<v-row v-if="item.status_send === 'error'" class="justify-center align-center mt-0">
								<v-col cols="12" justify="center" align="center">
									<strong class="color-white">{{ $t('ChatSide.messageError') }}</strong>
								</v-col>
							</v-row>
						</div>
						<!-- text -->
						<div class="message cursor" v-else-if="item.typeofmessage === 'message'"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['cancel', 'mention', 'forward', 'announce', 'copy']) : messageMenu($event, item, ['mention', 'forward', 'announce', 'copy'])"
							@click="handleClick">
							<p class="mb-0" v-html="convert(item.message, item).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
						</div>
						<!-- image -->
						<div class="image" v-else-if="item.typeofmessage === 'image'"
							@click="openMessage('image', item)"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['download', 'cancel', 'mention', 'forward', 'album', 'onebox', 'mail', 'copy-image']) : messageMenu($event, item, ['download', 'mention', 'forward', 'album','onebox', 'mail', 'copy-image'])">
							<img class="image cursor" :src="item.message" alt="" :lazy-src="item.message"
								lazy="loading">
						</div>
						<!-- video of audio -->
						<div :class="item.thumbnail !== undefined ? 'image cursor' : 'message cusor'"
							v-else-if="item.typeofmessage === 'video' || item.typeofmessage === 'audio'"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['download', 'cancel', 'mention', 'forward', 'onebox']) : messageMenu($event, item, ['download', 'mention', 'forward', 'onebox'])"
							@click="item.typeofmessage === 'video' ? openMessage('video', item) : ''">
							<v-img v-if="item.thumbnail !== undefined" :src="item.thumbnail" class="image"
								:lazy-src="item.thumbnail" lazy="loading">
								<template>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-icon class="iconimage">fa-solid fa-circle-play</v-icon>
									</v-row>
								</template>
							</v-img>
							<v-row v-else class="justify-start align-center">
								<v-col cols="2" align="center" justify="center">
									<v-icon class="iconfile">{{ extension(item.message) }}</v-icon>
								</v-col>
								<v-col cols="10" class="pl-5">
									{{ item.file_name }}
								</v-col>
							</v-row>
						</div>
						<!-- file -->
						<div :class="extension(item.message) === 'fa-solid fa-file-pdf' ? 'message cursor' : 'message'"
							v-else-if="item.typeofmessage === 'file' || item.typeofmessage === 'password_file'"
							@click="extension(item.message) === 'fa-solid fa-file-pdf' ? openMessage('file', item) : ''"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['download', 'cancel', 'mention', 'forward', 'onebox', 'mail']) : messageMenu($event, item, ['download', 'mention', 'forward', 'onebox', 'mail'])">
							<v-row class="justify-start align-center">
								<v-col cols="2" align="center" justify="center">
									<v-icon class="iconfile">{{ extension(item.message) }}</v-icon>
								</v-col>
								<v-col cols="10" class="pl-5">
									{{ item.file_name }}
								</v-col>
							</v-row>
						</div>
						<!-- location -->
						<div class="message cursor" v-else-if="item.typeofmessage === 'location'"
							@click="openMessage('location', item)"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['cancel', 'mention', 'forward']) : messageMenu($event, item, ['mention', 'forward'])">
							<v-row class="justify-start align-center">
								<v-col cols="2" align="center" justify="center">
									<v-icon class="iconfile">mdi-map-marker-circle</v-icon>
								</v-col>
								<v-col cols="10" class="pl-5">
									{{ item.file_name !== "" ? item.file_name : item.message }}
								</v-col>
							</v-row>
						</div>
						<!-- sticker -->
						<div :class="statusForward ? 'sticker cursor-dis' : 'sticker cursor'"
							v-else-if="item.typeofmessage === 'sticker'"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['cancel', 'mention']) : messageMenu($event, item, ['mention'])">
							<img :class="statusForward ? 'sticker cursor-dis' : 'sticker cursor'" :src="item.file_name"
								alt="" :lazy-src="item.file_name" lazy="loading">
						</div>
						<!-- contact -->
						<div :class="statusForward ? 'message cursor-dis' : 'message cursor'"
							v-else-if="item.typeofmessage === 'contact'" @click="openMessage('contact', item)">
							<v-row class="justify-start align-center">
								<v-col cols="3" align="center" justify="center" class="pr-0">
									<v-avatar size="40">
										<img v-if="item.pic_contact" :src="item.pic_contact"
											class="imgProfilechat pictureRoomChat alligator-turtle" />
										<img v-else-if="item.type_contact === 'bot'"
											:src="`${publicPath}/assets/img/default_profile/bot-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
										<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
									</v-avatar>
								</v-col>
								<v-col cols="9">
									<v-row class="justify-start align-center">
										<p class="mb-0 text-overflow-contact">{{ item.nickname_contact }}</p>
										<v-icon class="iconcontact">mdi-chevron-right</v-icon>
									</v-row>
								</v-col>
							</v-row>
						</div>
						<!-- mention message -->
						<div :class="statusForward ? 'messagemention cursor-dis' : 'messagemention cursor'"
							v-else-if="item.typeofmessage === 'mention_message'"
							@contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['mention']) : messageMenu($event, item, ['mention'])">
							<v-row justify="start" align="start">
								<v-col cols="2">
									<v-avatar size="40" class="border-avatar">
										<img v-if="item.source_message.owner_source_message.path_pic"
											:src="item.source_message.owner_source_message.path_pic"
											class="imgProfilechat pictureRoomChat alligator-turtle" />
										<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
											class="imgProfilechat pictureRoomChat alligator-turtle">
									</v-avatar>
								</v-col>
								<v-col
									:cols="item.source_message.typeofmessage === 'message' || item.source_message.typeofmessage === 'mention_message' ? 10 : 7"
									justify="start" align="start">
									<p class="mb-0 pl-5">{{ item.source_message.owner_source_message.nickname }}</p>
									<p class="mb-0 pl-5 pt-2"
										v-if="item.source_message.typeofmessage === 'message' || item.source_message.typeofmessage === 'mention_message'"
										v-html="convert(item.source_message.message, item.source_message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
									</p>
									<span class="mb-0 pl-5 pt-2" v-if="item.source_message.typeofmessage === 'file'">{{
										$t('ChatSide.file')
										}}</span>
									<span class="mb-0 pl-5 pt-2" v-if="item.source_message.typeofmessage === 'image'">{{
										$t('ChatSide.image')
										}}</span>
									<span class="mb-0 pl-5 pt-2"
										v-if="item.source_message.typeofmessage === 'sticker'">{{
											$t('ChatSide.sticker') }}</span>
									<span class="mb-0 pl-5 pt-2"
										v-if="item.source_message.typeofmessage === 'location'">{{
											$t('ChatSide.location') }}</span>
									<span class="mb-0 pl-5 pt-2" v-if="item.source_message.typeofmessage === 'video'">{{
										$t('ChatSide.video')
										}}</span>
									<span class="mb-0 pl-5 pt-2" v-if="item.source_message.typeofmessage === 'audio'">{{
										$t('ChatSide.audio')
										}}</span>
								</v-col>
								<v-col cols="3"
									v-if="item.source_message.typeofmessage !== 'message' && item.source_message.typeofmessage !== 'mention_message'"
									justify="center" align="center">
									<v-icon class="iconmention"
										v-if="item.source_message.typeofmessage === 'file' && extension(item.source_message.message) === 'fas fa-file-alt'">fas
										fa-file-pdf</v-icon>
									<v-icon class="iconmention"
										v-else-if="item.source_message.typeofmessage === 'file'">{{
											extension(item.source_message.message) }}</v-icon>
									<img v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'"
										:src="item.source_message.message" class="pictureRoomChat alligator-turtle"
										width="35px" height="35px" />
									<v-icon class="iconmention"
										v-else-if="item.source_message.typeofmessage === 'location'">fa-solid
										fa-map-location-dot</v-icon>
									<v-img v-else-if="item.source_message.typeofmessage === 'video'"
										:src="item.source_message.thumbnail" class="pictureRoomChat alligator-turtle"
										width="35px" height="35px">
										<template>
											<v-row class="fill-height ma-0" align="center" justify="center">
												<v-icon class="iconmention">fa-solid fa-circle-play</v-icon>
											</v-row>
										</template>
									</v-img>
									<v-icon class="iconmention"
										v-else-if="item.source_message.typeofmessage === 'audio'">fa-solid
										fa-file-audio</v-icon>
								</v-col>
							</v-row>
							<v-divider class="mt-2 color-divider"></v-divider>
							<v-row justify="start" class="mt-2 pl-3">
								<p v-html="convert(item.message, item).replace(/(?:\r\n|\r|\n)/g, '<br>')" style="display: block;
                    max-width: 23vw;
                    min-width: 23vw;
                    text-align: left;">
								</p>
							</v-row>
						</div>
						<!-- note -->
						<div :class="statusForward ? 'messagenote cursor-dis' : 'messagenote cursor'"
							v-else-if="item.typeofmessage === 'note'" @click="openMessage('note', item)">
							<v-row justify="start" align="center" class="pl-3 pt-2 pb-1">
								<v-col cols="12" class="pl-0">
									<p v-html="convert(item.message, item).replace(/(?:\r\n|\r|\n)/g, '<br>')"
										class="mb-0">
									</p>
									<p v-if="item.message.length == 20" class="mb-0">...</p>
								</v-col>
							</v-row>
							<v-divider class="mt-2 color-divider"></v-divider>
							<v-row justify="start" class="mt-2 pl-3 pr-2 pb-1">
								<span>{{ $t('ChatSide.note') }}</span>
								<v-spacer></v-spacer>
								<v-icon class="iconnote">mdi-chevron-right</v-icon>
							</v-row>
						</div>
						<!-- albums message -->
						<div :class="statusForward ? 'messagenote cursor-dis' : 'messagenote cursor'"
							v-else-if="item.typeofmessage === 'albums_message'" @click="openMessage('albums', item)">
							<v-row justify="start" align="center" class="pl-3 pt-2 pb-1">
								<p v-if="item.message === 'create_albums'" class="mb-0">{{
									$t('ChatSide.Album.createAlbumHeader') }}</p>
								<p v-else-if="item.message === 'addimage_albums'" class="mb-0">{{
									$t('ChatSide.Album.insertImageAlbum', {
										name:
											item.albums_name
									}) }}</p>
							</v-row>
							<v-row class="justify-center align-center pa-4" v-if="item.image_add.length !== 0">
								<v-col class="pa-0" cols="6" v-for="(item, index) in item.image_add" :key="index">
									<v-img v-if="index < 4" :src="item.link" :lazy-src="item.link"
										aspect-ratio="1"></v-img>
								</v-col>
							</v-row>
							<v-row justify="start" align="center" class="pl-3 pt-2 pb-1" v-if="item.image_add.length !== 0">
								<span>{{ $t('ChatSide.Album.numberImage', { count: item.image_add.length }) }}</span>
							</v-row>
							<v-divider class="mt-2 color-divider"></v-divider>
							<v-row justify="start" class="mt-2 pl-3 pr-2 pb-1">
								<span>{{ item.albums_name }}</span>
								<v-spacer></v-spacer>
								<v-icon class="iconnote">mdi-chevron-right</v-icon>
							</v-row>
						</div>
						<!-- official template -->
						<div class="template" v-else-if="item.typeofmessage === 'official_template'">
							<v-layout class="align-end pl-2 pr-2">
								<v-card class="mx-auto ma-3" max-width="232px" min-width="23vw">
									<v-img class="white--text align-end cursor" height="120px" :src="item.element.image"
										:lazy-src="item.element.image"
										v-if="item.element.image !== undefined && item.element.image !== ''"
										@click="ans_question_template(item.element.onclick_img, item)">
									</v-img>
									<v-card-title class="template-title">{{ item.element.title }}</v-card-title>
									<v-divider
										v-if="item.element.image === undefined || item.element.image === ''"></v-divider>
									<v-card-subtitle class="pb-0" v-if="item.element.detail !== ''">
										<p style="text-align: start; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;"
											class="mb-0"
											v-html="convert(item.element.detail, item).replace(/(?:\r\n|\r|\n)/g, '<br>')">
										</p>
										<a v-if="item.element.detail.length >= 40" @click="clickReadmore(item.element)"
											style="text-align: start; display: flex; margin-bottom: 20px;">
											<b>{{ $t('ChatSide.Read.readmore') }}</b>
										</a>
									</v-card-subtitle>

									<v-card-text class="text--primary">
										<v-row class="ma-2">
											<v-btn class="mb-1" @click="ans_question_template(action, item)" block text
												:style="checkbutton(action.color, action.background)"
												v-for="(action, index) in item.element.choice" :key="index"
												:disabled="(action.disable == '0') ? false : true">
												{{ action.label }}
											</v-btn>
										</v-row>
									</v-card-text>
								</v-card>
							</v-layout>
						</div>
						<!-- template -->
						<div class="template" v-else-if="item.typeofmessage === 'template'">
							<v-layout class="align-end">
								<div v-for="(msg, index) in item.info_ans" :key="index" class="pr-2 pb-2 pl-2">
									<v-card class="mx-auto ma-3" max-width="232px" min-width="23vw">
										<v-img class="white--text align-end" height="120px" :src="msg.image"
											:lazy-src="msg.image" v-if="msg.image !== undefined">
										</v-img>
										<v-card-title class="template-title">{{ msg.title }}</v-card-title>
										<v-divider v-if="msg.image === undefined"></v-divider>
										<v-card-subtitle class="pb-0" v-if="msg.detail !== ''">
											<p style="text-align: start; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;"
												class="mb-0"
												v-html="convert(msg.detail, msg).replace(/(?:\r\n|\r|\n)/g, '<br>')">
											</p>
											<a v-if="msg.detail.length >= 40" @click="clickReadmore(msg)"
												style="text-align: start; display: flex; margin-bottom: 20px;">
												<b>{{ $t('ChatSide.Read.readmore') }}</b>
											</a>
										</v-card-subtitle>

										<v-card-text class="text--primary">
											<v-row class="ma-2">
												<v-btn @click="ans_question_template(action, item)" block text
													class="template-btn mb-1" v-for="(action, index) in msg.choice"
													:key="index">
													{{ action.label }}
												</v-btn>
											</v-row>
											<!-- <v-row v-else>
												<li @click="ans_question(action, item.tokenmessage, item.tokenuser)" block text class="template-btn" v-for="(action, index) in msg.choice" :key="index">
													{{action.label}}
												</li>
											</v-row> -->
										</v-card-text>
									</v-card>
								</div>
							</v-layout>
						</div>
						<!-- image carousel -->
						<div class="template" v-else-if="item.typeofmessage === 'carousel'">
							<v-layout class="align-end">
								<div v-for="(info_carousel, index) in item.elements" :key="index" class="pr-2 pb-2">
									<v-card style="border-radius: 20px; width: 250px; margin-right: 10px;">
										<v-img
										@click="btn_answer_carousel(info_carousel)"
										:src="info_carousel.image"
										:aspect-ratio="16/9"
										v-if="info_carousel.image"
										style="height: 250px; cursor: pointer;"
										>
										<v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 250px;">
											<v-btn v-if="info_carousel.button" rounded color="#0000009c" dark>
											<span class="text-transform">{{info_carousel.button}}</span>
											</v-btn>
										</v-layout>
										</v-img>
									</v-card>
								</div>
							</v-layout>
						</div>
						<!-- task message -->
						<div class="messagetask cursor" v-else-if="item.typeofmessage === 'task_message'"
							@click="openMessage('task', item)">
							<v-row justify="start" align="center" class="pl-3 pt-2 pb-1">
								<v-col v-if="item.state.name !== undefined" cols="3" class="pr-0 pl-0 pt-0">
									<!-- <v-icon :color="checkPriorityTask(item.task_info.priority)">fa-solid fa-square</v-icon>
									<br> -->
									<v-chip dark small label :color="checkPriorityTask(item.task_info.priority)">
										{{ item.state.name }}
									</v-chip>
								</v-col>
								<v-col cols="9" class="pl-0 pt-0">
									<h3 class="mb-0 titletask">{{ item.project_name }}</h3>
									<p class="mb-0 detailtask">{{ item.title }}</p>
								</v-col>
							</v-row>
							<v-divider v-if="item.task_info.assign.length !== 0" class="icontask"></v-divider>
							<v-row v-if="item.task_info.assign.length !== 0"
								class="mt-1 justify-center align-center pa-4">
								<v-col class="pa-0 mb-1" cols="12" v-for="(item, index) in item.task_info.assign"
									:key="index">
									<v-chip label>
										<v-avatar size="20">
											<img v-if="item.path_pic" :src="item.path_pic" alt="alt"
												class="imgProfilechat pictureRoomChat alligator-turtle">
											<img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
												class="imgProfilechat pictureRoomChat alligator-turtle">
										</v-avatar>
										<p class="mb-0 pl-1 text-overflow">{{ item.nickname }}</p>
									</v-chip>
								</v-col>
							</v-row>
							<v-divider class="mt-2 color-divider"></v-divider>
							<v-row justify="start" class="mt-2 pl-3 pr-2 pb-1">
								<span v-if="item.message === 'assign_task'">{{ $t('ChatSide.Task.editAssign') }}</span>
								<span v-else-if="item.message === 'create_task'">{{ $t('ChatSide.Task.viewDetail')
									}}</span>
								<span v-else>{{ $t('ChatSide.Task.viewDetail') }}</span>
								<v-spacer></v-spacer>
								<v-icon class="icontask">mdi-chevron-right</v-icon>
							</v-row>
						</div>
						<!-- date & datetime -->
						<div class="message"
							v-else-if="item.typeofmessage === 'date' || item.typeofmessage === 'datetime'">
							<!-- @contextmenu="item.tokenuser == tokenuser ? messageMenu($event, item, ['cancel', 'mention', 'forward', 'announce', 'copy']) : messageMenu($event, item, ['mention', 'forward', 'announce', 'copy'])" -->
							<v-row
								:class="item.typeofmessage === 'date' ? 'justify-start align-center pa-2' : 'justify-start align-center pa-2 pb-0'"
								v-if="item.typeofmessage === 'date' || item.typeofmessage === 'datetime'">
								<v-icon class="iconmessage">fa-solid fa-calendar-days</v-icon>
								<p class="pa-2 mb-0">{{ dateMomentThai(item.message) }}</p>
							</v-row>
							<v-row
								:class="item.typeofmessage === 'datetime' ? 'justify-start align-center pa-2 mt-0' : 'justify-start align-center pa-2'"
								v-if="item.typeofmessage === 'datetime'">
								<v-icon class="iconmessage">fa-solid fa-clock</v-icon>
								<p class="pa-2 mb-0">{{ timeMomentThai(item.message) }}</p>
							</v-row>
						</div>
						<!-- not support type -->
						<div class="message" v-else>
							{{ $t("ChatSide.notSupportVersion") }} {{ item.typeofmessage }}
						</div>
						<div v-if="item.tokenuser !== tokenuser" class="ml-2">
							<span class="fz-11 color-grey">{{ timeMoment(item.timestamp) }}</span>
						</div>
					</v-row>
					<v-row
						:class="item.tokenuser === tokenuser ? 'justify-end mb-3 mr-2' : 'justify-end ml-14 mb-3 mr-10'"
						v-if="item.typeofmessage === 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video' || item.typeofmessage === 'audio' || item.typeofmessage === 'loading'">
						<span v-if="item.status_send === undefined" @click="downloadFile(item)"
							class="fz-12 color-grey pr-1 menu-message">{{ $t("AnswerQuestion.download") }}</span>
						<span class="menu-message fz-12 color-grey pl-0" @click="openMessage('onebox', item)"
							v-if="item.status_send === undefined && item.typeofmessage !== 'video'">| {{
								$t("AnswerQuestion.sendOnebox")
							}}</span>

						<span v-if="item.status_send == 'cancel-upload' || item.status_send == 'error'"
							@click="resendMessage(item, index)" class="fz-12 color-grey pr-1 menu-message">{{
								$t("ChatSide.resend") }}</span><span
							v-if="item.status_send == 'cancel-upload' || item.status_send == 'error'"
							class="menu-message fz-12 color-grey pl-0 pr-1">|</span><span
							class="menu-message fz-12 color-grey pl-0" @click="deleteMessage(item, index)"
							v-if="item.status_send == 'cancel-upload' || item.status_send == 'error'">{{
								$t("ChatSide.RightClickMenu.deleteMsg") }}</span>
					</v-row>
					<v-row :class="item.tokenuser === tokenuser ? 'justify-end mb-3 mr-2' : 'align-end ml-14 mb-3 mr-2'"
						v-else-if="item.status_send === 'error'">
						<span @click="resendMessage(item, index)" class="fz-12 color-grey pr-1 menu-message">{{
							$t("ChatSide.resend")
						}}</span><span class="menu-message fz-12 color-grey pl-0 pr-1">|</span><span
							class="menu-message fz-12 color-grey pl-0" @click="deleteMessage(item, index)"> {{
								$t("ChatSide.RightClickMenu.deleteMsg") }}</span>
					</v-row>
				</div>
			</v-col>
		</v-row>
		<v-snackbar
          v-model="snackbarCopy"
          :timeout="2000"
          top
          absolute
          text
          color="#2463af"
        >
          <span style="text-align: center; justify-content: center; display: flex;">{{$t('Alert.Chat.copyImage')}}</span>
        </v-snackbar>

		<Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning"
			@closeAlertDialog="closeAlertDialog"></Warning>
		<Error :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog">
		</Error>
		<ModalChat :tokenuser="tokenuser" :ModalChatDialog="ModalChatDialog" :ModalChatDetail="ModalChatDetail"
			@closeComponents="closeComponents" :room_name="room_name"></ModalChat>
		<SaveToOnebox :tokenuser="tokenuser" :SaveToOneboxDialog="SaveToOneboxDialog"
			:SaveToOneboxDetail="SaveToOneboxDetail" @closeComponents="closeComponents"></SaveToOnebox>
		<Location :LocationDialog="LocationDialog" :LocationDetail="LocationDetail" @closeComponents="closeComponents">
		</Location>
		<DetailFriend :DetailFriendDialog="DetailFriendDialog" :InforFriend="InforFriend"
			@closeComponents="closeComponents">
		</DetailFriend>
		<DetailNoteChat :DetailNoteChatDialog="DetailNoteChatDialog" :NoteDetail="NoteDetail"
			@closeComponents="closeComponents" @emitComponents="emitComponents"></DetailNoteChat>
		<NoteChat :NoteChatDialog="NoteChatDialog" :NoteChatDetail="NoteChatDetail" @closeComponents="closeComponents">
		</NoteChat>
		<CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" :checkBrowserInfor="checkBrowserInfor"
			@closeCheckBrowser="closeCheckBrowser"></CheckBrowserDialog>
		<WebviewBigDialogVue :tokenuser="tokenuser" :tokenroom="tokenroom" :dialogWebviewbig="dialogWebviewbig"
			:Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewBigDialogVue>
		<ReadmoreDialogVue :dialogReadmore="dialogReadmore" :detailReadmore="detailReadmore"
			@closeReadmoreDialog="closeReadmoreDialog"></ReadmoreDialogVue>
		<QrCodeRichMenuDialog :dialogQrcodRichMenu="dialogQrcodRichMenu" :tokenroom="tokenroom"
			@closedialogQrcode="closedialogQrcode" :QrcodeInfor="QrcodeInfor"></QrCodeRichMenuDialog>
		<AlbumsChat :AlbumsDialog="AlbumsDialog" :AlbumsRoom="tokenroom" :tokenuser="tokenuser" @closeComponents="closeComponents"></AlbumsChat>
		<DetailAlbums :DetailAlbumsDialog="DetailAlbumsDialog" :DetailAlbumsChatDialog="DetailAlbumsChatDialog" :AlbumsRoom="tokenroom" :tokenuser="tokenuser" @closeComponents="closeComponents"></DetailAlbums>
		<!-- <AddImageAlbumsChat :AddImageAlbumsDialog="AddImageAlbumsDialog" :DetailAlbums="DetailAlbumsDialog" :AlbumsRoom="tokenroom" :tokenuser="tokenuser" :ListAlbumsDetail="ListAlbumsDetail" :ListAlbumsImage="ListAlbumsImage" @emitComponents="emitComponents"></AddImageAlbumsChat> -->
		<ListAlbumChat :ListAlbumsDialog="ListAlbumsDialog" :ListAlbumsDetail="ListAlbumsDetail" :ListAlbumsImage="ListAlbumsImage" :AlbumsRoom="tokenroom" :tokenuser="tokenuser" @closeComponents="closeComponents"></ListAlbumChat>
		<SendMailVue :dialogCreatemail="dialogCreatemail" :message="sendMailDetail" :datauser="data_user" @closeComponents="closeComponents"></SendMailVue>
		<DetailTask :dialogDetailTask="dialogDetailTask" :taskid="taskid" :roomid="tokenroom" @closeDetailTask="closeDetailTask"></DetailTask>
	</div>
</template>
<script>
import { Momenttime, Encode } from "@/services";
import Warning from '@/components/Alert/Warning.vue';
import Error from '@/components/Alert/Error.vue';
import ModalChat from '@/views/Web/MenuChat/ModalChat.vue';
import SaveToOnebox from "./SaveToOnebox.vue";
import Location from "./Location.vue";
import DetailFriend from "@/components/DetailFriend.vue";
import DetailNoteChat from "@/components/DetailNoteChat.vue";
import NoteChat from "@/components/NoteChat.vue";
import AlbumsChat from "@/components/AlbumsChat.vue";
import DetailAlbums from "@/components/DetailAlbumsChat.vue";
import {
	copyImageToClipboard
} from 'copy-image-clipboard'
import CheckBrowserDialog from "@/components/dialog/CheckBrowserDialog.vue";
import WebviewBigDialogVue from '@/components/dialog/WebviewBigDialog.vue';
import ReadmoreDialogVue from '@/components/dialog/ReadmoreDialog.vue';
import QrCodeRichMenuDialog from "@/components/dialog/QrCodeRichMenuDialog.vue";
// import AddImageAlbumsChat from "@/components/AddImageAlbumsChat.vue";
import ListAlbumChat from '@/components/ListAlbumsChat.vue';
import SendMailVue from '@/components/SendMail.vue';
import DetailTask from '@/views/Web/Manage/task/detail_task_dialog_mo.vue';
var _ = require('lodash')
export default {
	components: {
		Warning,
		Error,
		copyImageToClipboard,
		ModalChat,
		SaveToOnebox,
		Location,
		DetailFriend,
		DetailNoteChat,
		NoteChat,
		CheckBrowserDialog,
		WebviewBigDialogVue,
		ReadmoreDialogVue,
		QrCodeRichMenuDialog,
		AlbumsChat,
		DetailAlbums,
		ListAlbumChat,
		SendMailVue,
		DetailTask
		// AddImageAlbumsChat
	},
	props: {
		listchat: {
			type: Array,
			required: true
		},
		tokenuser: String,
		statemember: String,
		typeRoom: String,
		room_name: String,
		tokenroom: String,
		EmitStatusForward: Boolean,
		data_user: Object,
		data_rich_menu: Object,
		listfriend: Array,
	},
	data() {
		return {
			snackbarCopy: false,
			dialogCreatemail: false,
			sendMailDetail: {},
			ListAlbumsDialog: false,
			AddImageAlbumsDialog: false,
			ListAlbumsDetail: [],
			ListAlbumsImage: [],
			DetailAlbumsDialog: {},
			DetailAlbumsChatDialog: false,
			AlbumsDialog: false,
			dialogQrcodRichMenu: false,
			QrcodeInfor: {},
			detailReadmore: {},
			dialogReadmore: false,
			Webview_item: {},
			dialogWebviewbig: false,
			checkBrowserDialog: false,
			checkBrowserInfor: {},
			selectedForward: [],
			NoteChatDetail: {},
			NoteChatDialog: false,
			DetailNoteChatDialog: false,
			NoteDetail: {},
			DetailFriendDialog: false,
			InforFriend: {},
			LocationDialog: false,
			LocationDetail: {},
			SaveToOneboxDetail: {},
			SaveToOneboxDialog: false,
			ModalChatDetail: {},
			ModalChatDialog: false,
			bufferValue: 20,
			WarningDialog: false,
			WarningDialogDetail: {},
			ErrorDialogDetail: {},
			ErrorDialog: false,
			publicPath: process.env.VUE_APP_BASE_PATH,
			stylechat: {
				"--Chat-Background": "white",
				"--Chat-HeaderColor": "white",
				"--Chat-HeaderBackground": "#2463af",
				"--Chat-HeaderPictureBorderRadius": "6px",
				"--Chat-ChatboxBackgroundOwner": "#34567f",
				"--Chat-ChatboxColorOwner": "white",
				"--Chat-ChatboxBorderOwner": "none",
				"--Chat-ChatboxBorderRadiusOwner": "6px",
				"--Chat-ChatboxColorNotSupportOwner": "#929292",
				"--Chat-ChatboxBackgroundOther": "#efefef",
				"--Chat-ChatboxColorOther": "#615f5f",
				"--Chat-ChatboxBorderOther": "none",
				"--Chat-ChatboxBorderRadiusOther": "6px",
				"--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
				"--Chat-TypingboxBackground": "#2463af",
				"--Chat-TypingboxColor": "white",
				"--Chat-QuickReplyButtonBorder": "#2463af",
				"--Chat-QuickReplyButtonBackground": "white",
				"--Chat-QuickReplyButtonColor": "#2463af",
				"--Chat-Icon-Active": "white",
				"--Chat-Template-Btn-Color": "#1976d2"
			},
			ListBottomMenu: false,
			ListBottomItem: [],
			statusForward: false,
			statusAlbum: false,
			statusNote: false,
			statusDeleteMsg: false,
			x: 0,
			y: 0,
			message_copy: '',
			menu_announce: false,
			text: "",
			showmenu_copy: false,
			dialogDetailTask: false,
			taskid: "",
		}
	},
	watch: {
		data_rich_menu: {
			handler(item) {
				if (item !== null) {
					var emit = { methods: 'clearDataRichMenu' }
					// ทำการรีเฟรชหรือจัดการกับ UI ที่จำเป็น
					// console.log('data_rich_menu has changed:', item);
					if (item.type === 'link' || item.type === 'webview') {
						this.$emit('emitMessage', emit)
						this.check_get_accesstoken(item)
					} else if (item.type === 'file') {
						this.$emit('emitMessage', emit)
						this.downloadFileMenu(item)
					} else if (item.type === 'link_market' || item.type === 'ocr') {
						this.$emit('emitMessage', emit)
						this.$swal({
							type: "warning",
							text: this.$t('Alert.Warning.link_market'),
							showConfirmButton: true,
							allowOutsideClick: false,
							confirmButtonText: this.$t('AnswerQuestion.ok')
						})
					} else if (item.type === 'ekyc') {
						this.$emit('emitMessage', emit)
						this.ans_ekyc_template(item, this.tokenuser)
					} else if (item.type === 'text') {
						item.methods = 'send-message'
						this.$emit('emitMessage', item)
					} else if (item.type === 'location') {
						if (window.navigator.geolocation) {
							var me = this
							window.navigator.geolocation.getCurrentPosition(function (position) {
								var location = {
									lat: position.coords.latitude.toString(),
									long: position.coords.longitude.toString(),
									address: '',
									tokenroom: me.tokenroom,
									tokenuser: me.tokenuser
								};
								item.methods = 'sendlocation'
								item.value = location
								me.$emit('emitMessage', item)
							},
								function (error) {
									console.log(error);
									var me = this
									me.$swal({
										type: "warning",
										text: 'Onechat needs access to use your current location, Please allow your location.',
										showConfirmButton: true,
										allowOutsideClick: false,
										confirmButtonText: me.$t('AnswerQuestion.ok')
									});
								})
						}
					} else if (item.type === "qrcode") {
						this.$emit('emitMessage', emit)
						item.status = item.location_status
						if (item.status === 'true') {
							var me = this
							window.navigator.geolocation.getCurrentPosition(function (position) {
								item.lat = position.coords.latitude
								item.lng = position.coords.longitude
								me.QrcodeInfor = item
								me.dialogQrcodRichMenu = true
							},
								function (error) {
									console.log(error);
									var me = this
									me.$swal({
										type: "warning",
										text: 'Onechat needs access to use your current location, Please allow your location.',
										showConfirmButton: true,
										allowOutsideClick: false,
										confirmButtonText: me.$t('AnswerQuestion.ok')
									});
								})
						} else {
							this.QrcodeInfor = item
							this.dialogQrcodRichMenu = true
						}
						
					}
				}
			},
			deep: true // ติดตามการเปลี่ยนแปลงใน nested properties
		},
		listchat: {
			handler(newVal) {
				// ทำการรีเฟรชหรือจัดการกับ UI ที่จำเป็น
				// console.log('listchat has changed:', newVal);
				// อัพเดต v-model ให้สอดคล้องกับ items ใหม่
				this.selectedForward = this.selectedForward.filter(selected =>
					newVal.some(item => item.tokenmessage === selected)
				);
				// for (let index = 0; index < newVal.length; index++) {
				//   const element = newVal[index];
				//   console.log("element => ", element);
				//   this.checkClassChatNotForward(element);
				//   this.checkClassChat(element, this.statusForward);
				// }
			},
			deep: true // ติดตามการเปลี่ยนแปลงใน nested properties
		},
		text() {
			console.log(this.text)
		},
		selectedForward(val) {
			// console.log("selectedForward =>", val);
			this.$emit('emitMessage', { methods: 'forward-lenght', value: val })
		},
		EmitStatusForward(val) {
			// console.log("watch statusForward", val);
			this.statusForward = val;
			if (!val) {
				this.selectedForward = [];
			}
			// this.checkClassChat('', this.statusForward)
		},
	},
	beforeUnmount() {
		this.$refs.textareaChat.removeEventListener('paste', this.onPaste);
	},
	mounted() {
		console.log("mounted");
		// check height chat
		// this.checkHeightChat()
		// set height message box
		// this.stylechat["--Chat-Height-Typer"] = `160px`

		// zoom image
		// this.setupWZoom();

		if (typeof window !== 'undefined') {
			window.addEventListener('mouseup', this.handleMouseUp);
		}
		if (this.$refs.textareaChat) {
			this.$refs.textareaChat.addEventListener('paste', this.onPaste);
		}
	},
	beforeDestroy() {
		console.log('beforeDestroy')
		window.removeEventListener('mouseup', this.handleMouseUp);
	},
	created() {
		// alert(JSON.stringify(this.listchat))
		// console.log("created listchat =>", this.listchat);
		// console.log("created tokenuser =>", this.tokenuser);
	},
	methods: {
		closeDetailTask (value) {
			this.dialogDetailTask = value
			this.taskid = ""
		},
		btn_answer_carousel (item) {
			// console.log("btn_answer_carousel =>", item);
			if (item.type === 'webview' || item.type === 'link') {
				var infor = {
				sign: item.sign,
				url: item.action,
				type: item.type,
				label: item.button,
				onechat_token: item.onechat_token,
				payload: item.payload,
				size: 'full'
				}
				this.check_get_accesstoken(infor)
			} else if (item.type === 'link_market') {
				this.$swal({
					type: "warning",
					text: this.$t('Alert.Warning.link_market'),
					showConfirmButton: true,
					allowOutsideClick: false,
					confirmButtonText: this.$t('AnswerQuestion.ok')
				})
			} else {
				this.ans_carousel(item)
			}
		},
		ans_carousel (item) {
			var payload = {}
			if (item.payload !== undefined) {
				payload = item.payload
			}
			var body = {
				tokenuser: this.tokenuser,
				tokenroom: this.tokenroom,
				action: item.action,
				type: item.type,
				payload: payload
			}
			this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/ansCarousel', body).then((response) => {
				// console.log(response.data)
			}).catch(error => {
				console.log(error)
			})
		},
		handleClick(e){
		const username = e.target.innerHTML.substring(1)
		const myUser = localStorage.name
		// console.log(myUser)
		if (username != myUser) {
			this.listfriend.forEach(freind =>{
				// var item = []
				const rex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
				var x = username.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
				var y = freind.name.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
				// console.log(x)
				// console.log(y)
				// console.log(x.includes(y))
				if(x.includes(y)){
				// console.log(freind)
				const tokenUser = freind.tokenuser
				this.openMessage('contact', { message: tokenUser }) 
				}
			})
		} else {
			// var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
			this.openMessage('contact', { message: this.tokenUser }) 
			// this.detailFriend(this.tokenuser)
		}

		},
		closedialogQrcode(val) {
			this.QrcodeInfor = {}
			this.dialogQrcodRichMenu = val
		},
		clickReadmore(item) {
			this.detailReadmore = item
			this.dialogReadmore = true
		},
		closeReadmoreDialog(value) {
			this.detailReadmore = {}
			this.dialogReadmore = value
		},
		closeWebview() {
			this.Webview_item = {}
			this.dialogWebviewbig = false
		},
		checkTypeMessage(type) {
			var message_type = ['note', 'mention_message', 'sticker', 'contact', 'albums_message', 'template', 'official_template', 'loading']
			// console.log(`message_type.includes(type) => ${type}`, message_type.includes(type));
			if (message_type.includes(type)) {
				return true
			} else {
				return false
			}
		},
		checkClassChatNotForward(item) {
			if (item.tokenuser === this.tokenuser) {
				// var element_self = this.$refs[`messageType-${item.tokenmessage}`]
				// if (element_self !== null && element_self !== undefined) {
				//   element_self[0].style = null
				// }
				return 'self'
			} else {
				// var element_friend = this.$refs[`messageType-${item.tokenmessage}`]
				// if (element_friend !== null && element_friend !== undefined) {
				//   element_friend[0].style = null
				// }
				return 'friend'
			}
		},
		checkClassChat(item, status) {
			var style_self = this.$refs[`messageType-${item.tokenmessage}`]
			var style_friend = this.$refs[`messageType-${item.tokenmessage}`]
			if (item.tokenuser === this.tokenuser && !status) {
				return 'self'
			} else if (item.tokenuser !== this.tokenuser && !status) {
				return 'friend'
			} else if (item.tokenuser === this.tokenuser && status) {
				if (style_self !== null && style_self !== undefined) {
					if (this.checkTypeMessage(item.typeofmessage)) {
						// เช็ค ui ตอนที่กดแชร์ข้อความให้เป็นเทา ๆ ยังบัคตอนโหลดข้อความเพิ่มแล้วไม่ ui ไม่ตรง
						// เดี๋ยวกลับมาแก้!!!
						// style_self[0].style['opacity'] = '0.6';
						// style_self[0].style['cursor'] = 'no-drop';
						// style_self[0].style['background-color'] = '#d9d9d9';
						// style_self[0].style['padding-top'] = '30px';
						return 'self'
					} else {
						// style_self[0].style = null
						return 'self'
					}
				} else {
					return 'self'
				}
			} else if (item.tokenuser !== this.tokenuser && status) {
				if (style_friend !== null && style_friend !== undefined) {
					if (this.checkTypeMessage(item.typeofmessage)) {
						// style_friend[0].style['opacity'] = '0.6';
						// style_friend[0].style['cursor'] = 'no-drop';
						// style_friend[0].style['background-color'] = '#d9d9d9';
						// style_friend[0].style['padding-top'] = '30px';
						return 'friend'
					} else {
						// style_friend[0].style = null
						return 'friend'
					}

				} else {
					return 'friend'
				}
			}
		},
		compareItems(idA, idB) {
			// เปรียบเทียบเฉพาะ id
			return idA === idB;
		},
		emitComponents(val) {
			// console.log("emitComponents =>", val);
			if (val.name === 'list-note') {
				this.NoteDetail = {};
				this.DetailNoteChatDialog = false;
				this.NoteChatDetail = val.item;
				this.NoteChatDialog = true;
			} else if (val.name === 'detail-note') {
				this.NoteDetail = {};
				this.DetailNoteChatDialog = false;
				this.NoteChatDetail = val.item;
				this.NoteChatDialog = true;
			} else if (val.name === 'add-image') {
				this.DetailAlbums = {}
				this.AddImageAlbumsDialog = false
			}
		},
		closeComponents(val) {
			// console.log("closeComponents =>", val);
			if (val.name === 'modal-chat') {
				this.ModalChatDetail = {};
				this.ModalChatDialog = val.value;
				this.$emit('emitMessage', { methods: 'openModal', value: this.ModalChatDialog })
			} else if (val.name === 'onebox') {
				this.SaveToOneboxDetail = {};
				this.SaveToOneboxDialog = val.value;
			} else if (val.name === 'sendlocation') {
				this.LocationDetail = {};
				this.LocationDialog = val.value;
			} else if (val.name === 'detailfriend') {
				this.InforFriend = {};
				this.DetailFriendDialog = val.value;
			} else if (val.name === 'detail-note') {
				this.NoteDetail = {};
				this.DetailNoteChatDialog = val.value;
			} else if (val.name === 'notechat') {
				this.NoteChatDetail = {};
				this.NoteChatDialog = val.value;
			} else if (val.name === 'albumschat') {
				this.AlbumsDialog = val.value;
			} else if (val.name === 'detail-album') {
				this.DetailAlbumsChatDialog = val.value;
				this.DetailAlbumsChat = {}
			} else if (val.name === 'list-albumschat') {
				this.ListAlbumsDialog = val.value
				this.ListAlbumsDetail = []
				this.ListAlbumsImage = []
			} else if (val.name === 'send-mail') {
				this.dialogCreatemail = val.value
				this.sendMailDetail = {}
			}
		},
		cancelUpload(item, index) {
			item.index = index
			item.status_send = 'cancel-upload'
			// console.log("cancel", item);
			this.$emit('emitMessage', item)
		},
		resendMessage(item, index) {
			// console.log("resend", item);
			item.index = index
			item.status_send = 'resend-msg'
			this.$emit('emitMessage', item)
		},
		deleteMessage(item, index) {
			// console.log(`delete-${index}`, item);
			item.index = index
			item.status_send = 'delete-msg'
			this.$emit('emitMessage', item)
		},
		checkCountRead(item) {
			// console.log(item);
			var me = this;
			var list_count = _.filter(item, function (o) { return o !== me.tokenuser })
			// console.log("list_count =>", list_count.length);
			return list_count.length
			// return '5'
		},
		openMessage(type, item) {
			// console.log(`openMessage ${type}=>`, item);
			var me = this;
			if (type === 'image' || type === 'file' || type === 'video') {
				me.ModalChatDetail = item;
				me.ModalChatDialog = true;
				this.$emit('emitMessage', { methods: 'openModal', value: me.ModalChatDialog })
			} else if (type === 'onebox') {
				this.SaveToOneboxDetail = item;
				this.SaveToOneboxDialog = true
			} else if (type === 'location') {
				this.LocationDetail = item;
				this.LocationDialog = true;
			} else if (type === 'contact' || type === 'detailfriend') {
				this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchtokenuser`, {
					tokenuser: this.tokenuser,
					tokenfriend: type === 'contact' ? item.message : item.tokenuser
				}).then((response) => {
					if (response.data.status === 'success') {
						this.InforFriend = response.data['user']
						this.InforFriend.backPage = `/chat-web/${this.tokenroom}`
						this.InforFriend.path = `/chat-web/${response.data['user']['tokenroom']}`
						this.InforFriend.statemember = response.data.relation
						this.DetailFriendDialog = true
					}
				}).catch(err => {
					console.log(err)
				})
			} else if (type === 'note') {
				this.NoteDetail = item;
				this.NoteDetail.previous = 'chat-room'
				this.DetailNoteChatDialog = true;
			} else if (type === 'albums') {
				item.album_id = item.file_name
				this.DetailAlbumsChatDialog = true;
				this.DetailAlbumsDialog = item
			} else if (type === 'task') {
				// console.log("task", item);
				this.taskid = item.task_id;
				this.dialogDetailTask = true;
			}
		},
		onPaste() {
			console.log("onPaste");
		},
		handleMouseUp() {
			const selection = window.getSelection().toString();
			if (selection.length > 0) {
				// แสดงเมนูให้คัดลอกทั้งหมด
				this.showmenu_copy = true
			} else {
				// แสดงเมนูคัดลอกเฉพาะที่เลือก
				this.showmenu_copy = false
			}
		},
		cancelMessage(item) {
			var body = {
				tokenmessage: item.message_id,
				tokenuser: this.tokenuser
			}
			this.axios.post(process.env.VUE_APP_API_message + `/delete_message`, body, {
			}).then((response) => {
				if (response.data.status == 'success') {
					this.listchat[item.index].typeofmessage = "unsend_message"
				}
			}).catch(err => {
				console.log(err)
				this.ErrorDialogDetail = {
					title: 'Error',
					text: this.$t('Alert.Fail.default.somethingWrong')
				}
				this.ErrorDialog = true
			})
		},
		emitWarning(value) {
			// console.log("emitWarning =>", value);
			this.WarningDialogDetail = {};
			this.WarningDialog = false;
			if (value.detail.methods == "cancel") {
				this.cancelMessage(value.detail)
			}
		},
		closeAlertDialog(value) {
			// console.log("close alert =>" ,value);
			if (value.type === 'err') {
				this.ErrorDialogDetail = {};
				this.ErrorDialog = false;
			} else if (value.type === 'warning') {
				this.WarningDialogDetail = {};
				this.WarningDialog = false;
			}
		},
		emitListMenu(item) {
			// console.log("emit menu", item);
			if (item.methods === "mention") {
				this.$emit('emitMessage', item)
			} else if (item.methods === "cancel") {
				this.WarningDialogDetail = {
					title: this.$t('Alert.Sure'),
					text: this.$t('Alert.Chat.unsent', {
						name: item.methods
					}),
					detail: item,
					index: ''
				}
				this.WarningDialog = true;
			} else if (item.methods === 'copy-all' || item.methods === 'copy') {
				this.doCopy(item.value.message, item.value)
			} else if (item.methods === 'copy-select') {
				this.handleCopyButtonClick()
			} else if (item.methods === 'copy-image') {
				this.doCopyImage(item.value.message)
			} else if (item.methods === "download") {
				this.downloadFile(item.value)
			} else if (item.methods === 'forward') {
				this.statusForward = true
				this.selectedForward = [item.value.tokenmessage]
				item.status = true;
				item.selected = this.selectedForward;
				this.$emit('emitMessage', item)
			} else if (item.methods === 'announce') {
				this.announceMessage(item)
			} else if (item.methods === 'album') {
				// open add image to album
				this.ListAlbumsDialog = true
				this.ListAlbumsImage = [item.value.message]
				this.ListAlbumsDetail = [item.value]
			} else if (item.methods === 'mail') {
				this.sendMailDetail = item.value
				this.dialogCreatemail = true
			}
		},
		announceMessage(item) {
			// console.log(item);
			this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/announce_room', {
				tokenuser: this.tokenuser,
				tokenmessage: item.value.tokenmessage,
				tokenroom: item.value.tokenroom
			}).then((response) => {
				if (response.data['status'] === 'success') {
					this.$swal({
						text: this.$t('Alert.Success.announce'),
						type: 'success',
						timer: 2000,
						showConfirmButton: false
					})
				}
				item.value = true
				this.$emit('emitMessage', item)
			}).catch((err) => {
				this.$swal({
					text: err.response.data.message,
					type: 'warning',
					showConfirmButton: true,
					confirmButtonText: this.$t('AnswerQuestion.ok')
				})
			})
		},
		downloadFile(item) {
			// console.log("downloadFile", item);
			// console.log("encodeURIComponent(item.original_file) =>", encodeURIComponent(item.original_file));
			this.axios.get(item.typeofmessage === 'video' ? item.original_file  : item.message, {
				responseType: 'blob'
			}).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', item.file_name)
				document.body.appendChild(link)
				link.click()
			})
		},
		doCopy(message, item) {
			// console.log("doCopy =>", message);
			// console.log(item);
			var me = this
			me.$copyText(me.convert(message, item)).then(function () { }, function (e) {
				console.log(e)
			})
		},
		async doCopyImage(url) {
			console.log("doCopyImage =>", url);
			var me = this
			copyImageToClipboard(url).then(() => {
				// console.log('Image Copied')
				me.snackbarCopy = true
				})
				.catch((e) => {
				console.log('Error: ', e.message)
				})
		},
		handleCopyButtonClick() {
			this.copyToClipboard(this.text);
		},
		copyToClipboard(text) {
			var dummy = document.createElement("textarea");
			dummy.style.display = "none";
			document.body.appendChild(dummy);
			dummy.value = text;
			dummy.select();
			document.execCommand("copy");
			document.body.removeChild(dummy);
			this.showmenu_copy = false
		},
		messageMenu(e, item, menu) {
			this.ListBottomMenu = false
			this.menu_announce = false
			// console.log('menu_announce =>', this.menu_announce);
			// console.log('item: ', item)
			// console.log('menu: ', menu)
			const index = this.listchat.indexOf(item);
			// console.log('this.selected_image: ', this.selected_image);
			var data = ''
			var data_index = 0
			var sender_id = ''
			if (item.list !== undefined) {
				data = item
				data_index = item.index
				sender_id = item.item.tokenuser
			} else {
				data = item
				data_index = index
				sender_id = item.tokenuser
			}
			e.preventDefault() // คลิกขวาแล้วไม่ให้แสดงเมนูของเว็บเบราว์เซอร์
			this.ListBottomItem = []
			this.ListBottomMenu = false
			this.message_copy = data.message // message copy all

			// // คลิกขวาหลังจากให้เลือกรูป
			// if (item.list !== undefined) {
			//   if (this.selected_image_status) {
			//     if (this.selected_image[data_index].length > 1) {
			//       // ถ้าเลือกมากกว่า 1 รูปจะ mentionไม่ได้
			//       menu = ['select-total', 'select-cancel', 'cancel', 'download', 'forward', 'album', 'keep', 'delete', 'note']
			//     } else if (this.selected_image[data_index].length === 1) {
			//       menu = ['select-total', 'select-cancel', 'mention', 'download', 'cancel','forward', 'album', 'keep', 'delete', 'note']
			//     }
			//   } else {
			//     menu = ['select', 'download', 'forward', 'album', 'keep', 'delete', 'note']
			//   }
			// }

			// console.log(menu);
			if (this.statemember && !this.statusForward && !this.statusAlbum && !this.statusNote && !this.statusDeleteMsg) {
				if (menu.includes('gotomsg')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.goToMsg'),
						methods: 'gotomsg',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('image')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.openimage'),
						methods: 'image',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('file')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.openfile'),
						methods: 'file',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('video')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.openvideo'),
						methods: 'video',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('audio')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.openaudio'),
						methods: 'audio',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('openmap')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.openlocation'),
						methods: 'openmap',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('select')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.select-image'),
						methods: 'select',
						icon: '',
						// value: item.list,
						// index: item.index,
						// item: item.item
						// icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('select-total')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.select-total', { total: this.checkLength(this.selectedForward) }),
						methods: 'select-total',
						icon: '',
						value: data,
						index: data_index,
						divider: true
					})
				}
				if (menu.includes('select-cancel')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.select-cancel'),
						methods: 'select-cancel',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('download')) {
					this.ListBottomItem.push({
						text: this.$t('AnswerQuestion.download'),
						methods: 'download',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('copy-image')) {
				  this.ListBottomItem.push({
				    text: this.$t('ChatSide.RightClickMenu.copy-all'),
				    methods: 'copy-image',
				    icon: '',
				    value: data,
				    index: data_index
				  })
				}
				if (menu.includes('mention')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.mention'),
						methods: 'mention',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (sender_id === this.tokenuser) {
					if (menu.includes('cancel')) {
						this.ListBottomItem.push({
							text: this.$t('ChatSide.RightClickMenu.cancelMsg'),
							methods: 'cancel',
							icon: '',
							value: data,
							index: data_index,
							// message_id: this.selectedForward[data_index]
							message_id: data.tokenmessage
						})
					}
				}

				if (menu.includes('forward')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.forward'),
						methods: 'forward',
						icon: '',
						value: data,
						index: data_index
					})
				}

				if (menu.includes('album')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.addImageAlbum'),
						methods: 'album',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('announce')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.announce'),
						methods: 'announce',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('keep')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.keep'),
						methods: 'keep',
						icon: '',
						value: data,
						index: data_index
					})
				}

				if (menu.includes('note')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.note'),
						methods: 'note',
						icon: '',
						value: data,
						index: data_index
					})
				}

				if (menu.includes('announce-cancel')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.cancelAnnounce'),
						methods: 'announce-cancel',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('mail')) {
					this.ListBottomItem.push({
						text: this.$t('Dialog.sendEmail.header'),
						methods: 'mail',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('announce-delete')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.deleteAnnounce'),
						methods: 'announce-delete',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (menu.includes('delete')) {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.deleteMsg'),
						methods: 'delete',
						icon: '',
						value: data,
						index: data_index
					})
				}
				// แสดงเมนูคัดลอกข้อความที่เลือก
				if (this.showmenu_copy && data.typeofmessage === 'message') {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.copy-select'),
						methods: 'copy-select',
						icon: '',
						value: data,
						index: data_index
					})
				}
				// แสดงเมนูคัดลอกทั้งหมด
				if (!this.showmenu_copy && data.typeofmessage === 'message') {
					this.ListBottomItem.push({
						text: this.$t('ChatSide.RightClickMenu.copy-all'),
						methods: 'copy-all',
						icon: '',
						value: data,
						index: data_index
					})
				}
				if (this.ListBottomItem.length !== 0) {
					var me = this
					this.x = e.clientX - 150
					this.y = e.clientY

					this.$nextTick(() => {
						// ถ้าข้อความนั้นส่งไม่ผ่านจะไม่แสดง contextmenu
						if (item.status_send === 'error') {
							me.ListBottomMenu = false
						} else {
							me.ListBottomMenu = true
						}
					})
				}
			}
			// console.log('ListBottomItem: ', this.ListBottomItem);
		},
		checkPriorityTask(value) {
			if (value === '1') {
				return '#b3493d';
			} else if (value === '2') {
				return '#fcbe54';
			} else {
				return '#a0a1a3';
			}
		},
		checkbutton(color, bng) {
			var text = {
				'text-transform': 'none',
				'width': '100%',
				'margin': '0',
				// 'font-size': '13px',
				// 'border-radius': '20px'
			}
			// [choice.color]? ('color': choice.color):('color':'black')
			if (color) {
				text['color'] = color
			} else {
				text['color'] = 'black'
			}
			if (bng) {
				text['background'] = bng
			} else {
				text['background'] = 'none'
			}
			return text
		},
		ans_question_template(item, data) {
			// console.log("ans_question", data);
			// ถ้า type ข้อความเป็น template หรือพวก quick reply ให้ยิง api ans
			if (data.typeofmessage !== 'official_template') {
				this.ans_question(item, data.tokenmessage);
			}

			if (item.type === 'link' || item.type === 'webview') {
				this.check_get_accesstoken(item)
			} else if (item.type === 'file') {
				this.downloadFileMenu(item)
			} else if (item.type === 'link_market' || item.type === 'ocr') {
				this.$swal({
					type: "warning",
					text: this.$t('Alert.Warning.link_market'),
					showConfirmButton: true,
					allowOutsideClick: false,
					confirmButtonText: this.$t('AnswerQuestion.ok')
				})
			} else if (item.type === 'ekyc') {
				this.ans_ekyc_template(item, data.tokenuser)
			}
		},
		ans_ekyc_template(item, tokenbot) {
			// console.log(item)
			this.axios.post(process.env.VUE_APP_API_message + '/api/v1/get_shared_token',
				{ user_id: this.data_user.one_id }).then((response) => {
					if (response.data.status === 'success') {
						var url = `${process.env.VUE_APP_URL_EKYC}${response.data.data.shared_token}&bot_id=${tokenbot}`
						this.Webview_item = {
							label: item.label,
							url: url,
							size: 'full',
							type: 'ekyc',
							payload: ''
						}
						this.checkBrowser(url, this.Webview_item)
					}
				}).catch(error => {
					console.log(error)
					this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
				})
		},
		closeCheckBrowser(value) {
			this.checkBrowserDialog = value
			this.checkBrowserInfor = {}
		},
		checkBrowser(url, item) {
			// console.log(item)
			if (_.includes(url, `${process.env.VUE_APP_QRcode}/qrcode/friend?id=`)) {
				var link = _.split(url, '?id=', 2)
				var item_friend = {}
				item_friend.message = link
				// this.detailFriend(atob(link[1]))
				this.openMessage('detailfriend', item_friend)
			} else {
				// Get the user-agent string
				let userAgentString = navigator.userAgent;
				// Detect Chrome
				let chromeAgent = userAgentString.indexOf("Chrome") > -1;
				// Detect Internet Explorer
				let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
				// Detect Firefox
				let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
				// Detect Safari
				let safariAgent = userAgentString.indexOf("Safari") > -1;
				// Discard Safari since it also matches Chrome
				let operaAgent = userAgentString.indexOf("OP") > -1;
				if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
					if (item.payload !== undefined && item.payload !== null) {
						if (item.payload.news_id !== undefined) {
							this.checkBrowserInfor = {
								url: url,
								payload: item.payload
							}
						} else {
							this.checkBrowserInfor = {
								url: url
							}
						}
					} else {
						this.checkBrowserInfor = {
							url: url,
							payload: ''
						}
					}
					this.checkBrowserDialog = true
				} else if (safariAgent === true && chromeAgent === true) {
					//  console.log('savelog')
					window.open(url, '_blank')
					if (item.payload !== undefined && item.payload !== null) {
						if (item.payload.news_id !== undefined) {
							this.saveLogNews(item)
						}
					}
				} else if (safariAgent === true) {
					if (item.payload !== undefined && item.payload !== null) {
						if (item.payload.news_id !== undefined) {
							this.checkBrowserInfor = {
								url: url,
								payload: item.payload
							}
						} else {
							this.checkBrowserInfor = {
								url: url
							}
						}
					} else {
						this.checkBrowserInfor = {
							url: url,
							payload: ''
						}
					}
					this.checkBrowserDialog = true
				} else {
					// console.log('savelog')
					window.open(url, '_blank')
					if (item.payload !== undefined && item.payload !== null) {
						if (item.payload.news_id !== undefined) {
							this.saveLogNews(item)
						}
					}
				}
			}
		},
		check_get_accesstoken(item) {
			// console.log("check_get_accesstoken =>", item)
			if (item.sign === 'true' || item.sign_share === 'true') {
				var body = {
					"tokenuser": this.tokenuser,
					"url": item.url
				}
				this.axios.post(process.env.VUE_APP_API_alpine + '/v1/getAccesstoken', body).then((response) => {
					// console.log(response.data)
					if (response.data.data) {
						var new_url = response.data.data.url
						if (item.type === 'link') {
							this.checkBrowser(new_url, item)
						} else if (item.type === 'webview') {
							this.Webview_item = {
								label: item.label,
								url: new_url,
								size: item.size,
								type: item.type
							}
							this.dialogWebviewbig = true
							if (item.payload !== undefined && item.payload !== null) {
								if (item.payload.news_id) {
									this.saveLogNews(item)
								}
							}
						}
					} else {
						this.dialogLogin = true
					}
				}, (error) => {
					console.log(error)
				})
			} else if (item.onechat_token === 'true') {
				var today = new Date()
				var dd = String(today.getDate()).padStart(2, '0')
				var hour = String(today.getHours() + 1).padStart(2, '0')
				var minute = String(today.getMinutes()).padStart(2, '0')
				var seconds = String(today.getSeconds()).padStart(2, '0')
				var milsec = today.getMilliseconds()
				var mm = String(today.getMonth() + 1).padStart(2, '0')
				var yyyy = today.getFullYear()
				// เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
				if (hour === '24') {
					hour = '00'
					dd = String(today.getDate() + 1).padStart(2, '0')
					var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
					// เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
					if (parseInt(dd) === date_of_month) {
						// ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
						dd = '1'
						// เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
						if (mm === '12') {
							// ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
							mm = '1'
							yyyy = today.getFullYear() + 1
						} else {
							// ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
							mm = String(today.getMonth() + 2).padStart(2, '0')
							// console.log(mm)
						}
					}
				}
				today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
				// console.log(today)
				var expireddate = Date.parse(today)
				// console.log(expireddate)
				var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
				var url = ''
				if (_.includes(item.url, ['?'])) {
					url = '&'
				} else {
					url = '?'
				}
				var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate
				if (item.type === 'link') {
					this.checkBrowser(weburl, item)
				} else if (item.type === 'webview') {
					this.Webview_item = {
						label: item.label,
						url: weburl,
						size: item.size,
						type: item.type
					}
					this.dialogWebviewbig = true
					if (item.payload !== undefined && item.payload !== null) {
						if (item.payload.news_id) {
							this.saveLogNews(item)
						}
					}
				}
			} else {
				if (item.type === 'link') {
					this.checkBrowser(item.url, item)
				} else if (item.type === 'webview') {
					this.Webview_item = item
					this.dialogWebviewbig = true
					// check payload news
					if (item.payload !== undefined && item.payload !== null) {
						if (item.payload.news_id) {
							this.saveLogNews(item)
						}
					}
				}
			}
		},
		saveLogNews(item) {
			// console.log("saveLogNews", item);
			this.axios.get(process.env.VUE_APP_API_GO + '/v1/getOneID/' + this.token).then((response) => {
				var one_id = response.data.one_id
				// console.log(one_id)
				this.axios.post(process.env.VUE_APP_API_NEWS, {
					'one_id': one_id,
					'news_id': item.payload.news_id,
					'news_index': item.payload.news_index.toString(),
					'page_name': item.payload.page_name
				}).then((response) => {
					// console.log(response)
				}).catch(error => {
					console.log(error)
				})
			}, (error) => {
				console.log(error)
			})
		},
		downloadFileMenu(item) {
			var name = item.file.split('/')[item.file.split('/').length - 1]
			this.axios.get(item.file, {
				responseType: 'blob'
			}).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', name)
				document.body.appendChild(link)
				link.click()
			})
		},
		async ans_question(item, tokenmessage) {
			if (item.payload === undefined) {
				item.payload = null
			}
			var body = {
				tokenmessage: tokenmessage,
				tokenuser: this.tokenuser,
				answer: item
			}
			await this.axios.post(process.env.VUE_APP_API_ALPINE + '/answer_question', body).then((response) => {
				if (item.type === 'text') {
					this.$emit('emitMessage', { methods: 'insertmessage', value: response.data.data })
				}
			}).catch(error => {
				console.log(error)
			})
		},
		convert(msg, item) {
			var linkifyStr = require('linkifyjs/string')
			var str = msg
			var processedContent = linkifyStr(str, { target: { url: '_blank' } })
			var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g
			var color = ''
			if (item.tokenuser == this.tokenuser) {
				color = '#06bee1'
			} else {
				color = '#1976d2'
			}
			// console.log(style)
			if (msg.match(regex)) {
				for (var i = 0; i < msg.match(regex).length; i++) {
					processedContent = processedContent.replace('&lt;tax&gt;', `<b style="color: ${color};">@`)
					processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
					processedContent = processedContent.replace('\t', '\u00a0\u00a0\u00a0\u00a0\u00a0')
				}
			}
			return processedContent
		},
		convertURL(msg) {
			var urlRegex = /\bhttps?:\/\/\S+/gi;
			var linkmsg = item.match(urlRegex)
			if (linkmsg !== null) {
				if (linkitem.length !== 0) {
					linkitem.length = 1
					return linkmsg
				}
				return ''
			} else {
				return ''
			}
		},
		timeMomentThai(data) {
			return data.split('T')[1]
		},
		dateMomentThai(data) {
			if (this.$i18n.locale == 'th') {
				return Momenttime.dayjsdatetimethai(data)
			} else if (this.$i18n.locale == 'cn') {
				return Momenttime.dayjsdatecn(data)
			} else {
				return Momenttime.dayjsdateen(data)
			}
		},
		timeMoment(data) {
			return Momenttime.dayjstimethai(data)
		},
		dateMoment(data) {
			if (this.$i18n.locale == 'th') {
				return Momenttime.dayjsdatethai(data)
			} else if (this.$i18n.locale == 'cn') {
				return Momenttime.dayjsdatecn(data)
			} else {
				return Momenttime.dayjsdateen(data)
			}
		},
		extension(path) {
			var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
			var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
			var pdf = ['pdf']
			var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm']
			var presentation = ['ppt', 'pps', 'pot', 'pptx']
			var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
			var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
			var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
			var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
			var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
			if (pdf.includes(extension)) {
				return 'fa-solid fa-file-pdf'
			} else if (archive.includes(extension)) {
				return 'fas fa-file-archive'
			} else if (spreadsheet.includes(extension)) {
				return 'fas fa-file-excel'
			} else if (presentation.includes(extension)) {
				return 'fas fa-file-powerpoint'
			} else if (word.includes(extension)) {
				return 'fas fa-file-word'
			} else if (execution.includes(extension)) {
				return 'fas fa-file-code'
			} else if (image.includes(extension)) {
				return 'fas fa-file-image'
			} else if (media.includes(extension)) {
				return 'fa-solid fa-file-audio'
			} else if (audio.includes(extension)) {
				return 'fa-solid fa-file-audio'
			} else {
				return 'fas fa-file-alt'
			}
		},
	},
}
</script>
<style scoped>
.text-transform {
	text-transform: none !important;
}
.bg-checkbox {
	background-color: #d9d9d9;
	opacity: 0.6;
}

.dis-cursor {
	cursor: no-drop;
}

.color-white {
	color: white !important;
}

.span-resend {
	font-size: 12px !important;
	cursor: pointer !important;
	color: #000000a6 !important;
}

.span-resend:hover {
	font-size: 12px !important;
	text-decoration: underline !important;
	cursor: pointer !important;
	color: #000000a6 !important;
}

>>>a {
	color: #00c3ff;
}

>>>a:hover {
	color: #00c3ff;
	text-decoration: underline;
}

.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-o-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

.text-overflow-contact {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 9em;
	text-align: start;
	padding-left: 20px;
}

.menu-message:hover {
	text-decoration: underline;
	cursor: pointer;
}

.fz-12 {
	font-size: 12px !important;
}

.color-grey {
	color: gray;
}

.systemDateNonMGT {
	padding: 3px;
	border-radius: 20px;
	background: #e8e8e875 !important;
	font-size: 12px;
	color: #808080b8;
	width: max-content;
	display: flex;
	justify-content: center;
	text-align: center !important;
	margin: auto;
	margin-bottom: 5px;
}

.systemDate {
	padding: 3px;
	border-radius: 20px;
	background: #e8e8e875 !important;
	font-size: 12px;
	color: #808080b8;
	width: max-content;
	display: flex;
	justify-content: center;
	text-align: center !important;
	margin: auto;
	margin-top: 30px;
	margin-bottom: 5px;
}

.fz-11 {
	font-size: 11px;
}

.alligator-turtle {
	object-fit: cover;
	object-position: 50% 0;
}

.pictureRoomChat {
	border-radius: var(--Chat-HeaderPictureBorderRadius) !important;
}

.HeaderName {
	color: var(--Chat-HeaderColor) !important;
	margin-left: 10px;
	font-size: 22px;
	font-weight: 600;
}

.imgProfilechat {
	height: 40px;
	vertical-align: middle;
}

.cursor {
	cursor: pointer;
}

.cursor-dis {
	cursor: no-drop;
}

.self {
	justify-items: end !important;
	display: grid !important;
}

.self-forward {
	justify-items: end !important;
	display: grid !important;
	opacity: 0.6 !important;
	cursor: no-drop !important;
	background-color: #ececec !important;
}

.self .system {
	justify-items: center !important;
	display: flex !important;
	width: 100% !important;
}

.self .message {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	color: var(--Chat-ChatboxColorOwner) !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 26vw !important;
	background: var(--Chat-ChatboxBackgroundOwner) !important;
	padding: 10px !important;
	float: right !important;
}

.self .messagemention {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	color: var(--Chat-ChatboxColorOwner) !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 26vw !important;
	background: var(--Chat-ChatboxBackgroundOwner) !important;
	padding: 10px !important;
	float: right !important;
}

.self .messagenote {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	color: var(--Chat-ChatboxColorOwner) !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 26vw !important;
	min-width: 26vw !important;
	background: var(--Chat-ChatboxBackgroundOwner) !important;
	padding: 10px !important;
	float: right !important
}

.self .messagetask {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	color: var(--Chat-ChatboxColorOwner) !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 26vw !important;
	min-width: 26vw !important;
	background: var(--Chat-ChatboxBackgroundOwner) !important;
	padding: 10px !important;
	float: right !important
}

.self .image {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 16vw !important;
	float: right !important;
}

.self .image .iconimage {
	color: white;
	font-size: 60px;
}

.self .message .iconmessage {
	color: white;
	font-size: 20px;
}

.self .messagemention .iconmention {
	color: white;
	font-size: 20px;
}

.self .messagenote .iconnote {
	color: white;
	font-size: 20px;
}

.self .messagetask .icontask {
	color: white;
	font-size: 20px;
}

.self .messagetask .titletask {
	color: white;
	font-size: 18px;
}

.self .messagetask .detailtask {
	color: #bfbfbf;
	font-size: 14px;
}

.self .sticker {
	text-align: left !important;
	margin-bottom: 0 !important;
	position: relative !important;
	max-width: 12vw !important;
	float: right !important;
}

.self .message .iconfile {
	color: white;
	font-size: 40px;
}

.self .message .iconfile-error {
	color: #ffca00;
	font-size: 40px;
}

.self .message .iconcontact {
	color: white;
	font-size: 30px;
}

.self .checkbox-content {
	display: block !important;
	float: left !important;
}

.friend .checkbox-content {
	display: inline-block !important;
}

.friend {
	justify-items: start !important;
	display: grid !important;
}

.friend-forward {
	justify-items: start !important;
	display: grid !important;
	opacity: 0.6 !important;
	cursor: no-drop !important;
	background-color: #ececec !important;
}

.friend .system {
	justify-items: center !important;
	display: flex !important;
	width: 100% !important;
}

.friend .template {
	min-width: 25vw;
	max-width: 50vw;
	overflow-x: scroll;
	overflow-y: hidden;
}

.friend .template::-webkit-scrollbar {
	height: 6px;
	width: 4px;
	cursor: pointer;
}

.friend .template::-webkit-scrollbar-thumb {
	border-radius: 5px;
	background: rgba(0, 0, 0, .1);
}

.friend .template .template-title {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
}

.friend .template .template-btn {
	color: var(--Chat-Template-Btn-Color) !important;
	text-transform: none !important;
}

.friend .template .template-btn:hover {
	background-color: var(--Chat-Template-Btn-Color) !important;
	color: white !important;
	/* background-color: #34567fab !important;
	color: var(--Chat-Template-Btn-Color) !important; */
	text-transform: none !important;
}

.friend .message {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	background: #efefef !important;
	padding: 10px !important;
	font-weight: 400 !important;
	color: #000 !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	float: left !important;
	max-width: 26vw !important;
}

.friend .messagenote {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	color: #000 !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 26vw !important;
	min-width: 26vw !important;
	background: #efefef !important;
	padding: 10px !important;
	float: right !important
}

.friend .messagetask {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	color: #000 !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	max-width: 26vw !important;
	min-width: 26vw !important;
	background: #efefef !important;
	padding: 10px !important;
	float: right !important
}

.friend .messagemention {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	background: #efefef !important;
	padding: 10px !important;
	font-weight: 400 !important;
	color: #000 !important;
	font-size: 13px !important;
	position: relative !important;
	word-wrap: break-word !important;
	float: left !important;
	max-width: 26vw !important;
}

.friend .image {
	text-align: left !important;
	margin-bottom: 0 !important;
	border-radius: 10px !important;
	position: relative !important;
	float: left !important;
	max-width: 16vw !important;
}

.friend .image .iconimage {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 60px;
}

.friend .message .iconmessage {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 20px;
}

.friend .messagenote .iconnote {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 20px;
}

.friend .messagetask .icontask {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 20px;
}

.friend .messagetask .titletask {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 18px;
}

.friend .messagetask .detailtask {
	color: rgba(0, 0, 0, 0.65) !important;
	font-size: 14px;
}

.friend .messagemention .iconmention {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 20px;
}

.friend .sticker {
	text-align: left !important;
	margin-bottom: 0 !important;
	position: relative !important;
	float: left !important;
	max-width: 12vw !important;
}

.friend .message .iconfile {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 40px;
}

.friend .message .iconcontact {
	color: var(--Chat-ChatboxBackgroundOwner) !important;
	font-size: 30px;
}

.username {
	font-size: 14px;
	font-weight: bold;
	color: #1569bb;
	padding: 10px;
}
</style>